import React from 'react';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const PieChartNoData = ({text, height = 300}) => {
    return (
        <Grid
            style={{height:height+'px', backgroundColor: 'rgba(0, 0, 0, 0.04)'}}
            container
            direction="row"
            justifyContent="center"
            alignItems="center">
            <Grid item>
                <Typography variant="body2" color="textSecondary" component="p">
                    {text}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default PieChartNoData;